export default "__VITE_ASSET__BGNOB2PT__"